import Header from "components/header";
import React from "react";
import { Outlet } from "react-router-dom";

export default function MobileLayout() {
  return (
    <div className="h-full w-full flex flex-col gap-4">
      <Header />
      <div className="px-4 h-[calc(100%-64px)] overflow-y-scroll pb-10">
        <Outlet />
      </div>
    </div>
  );
}
